<script setup lang="ts">
const { $config } = useNuxtApp()
</script>

<template>
  <footer class="TheFooter">
    <div class="TheFooter__terms">
      <a
        class="TheFooter__termsItem"
        :href="$config.public.cnn.termsOfService"
        :target="'_blank'"
      >
        아이디어스 서비스 작가(판매)회원 이용약관
      </a>
      <div class="TheFooter__termsItemSeparator">|</div>
      <a
        class="TheFooter__termsItem TheFooter__termsItem--privacy"
        :href="$config.public.cnn.privacyPolicy"
        :target="'_blank'"
      >
        개인정보 처리방침
      </a>
    </div>
    <div class="TheFooter__content">
      <p class="TheFooter__contentCompanyName">(주) 백패커</p>
      <p class="TheFooter__contentCompanyInfo">
        서울시 서초구 서초대로 398 BNK디지털타워 20층 ㅣ 대표이사 : 김동환
      </p>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.TheFooter {
  @apply px-[12px] pt-[40px] pb-[60px];
  @apply gray-666--text;
  @apply gray-f5--background;

  &__content {
    @apply flex flex-col items-center;

    &CompanyName {
      @apply caption2_bold_small;
      @apply mb-[4px];
    }

    &CompanyInfo {
      @apply caption2_regular_small;
    }
  }

  &__terms {
    @apply w-full h-full;
    @apply flex justify-center items-center;
    @apply mx-auto px-4 pb-[12px];

    &Item {
      @apply caption2_regular_small;

      &--privacy {
        @apply caption2_bold_small;
      }
    }

    &ItemSeparator {
      @apply px-[4px] caption2_regular_small;
    }
  }
}
</style>
